import { createIcon } from '../createIcon';

export const CreditCardIconConfig = {
  name: 'CreditCardIcon',
  height: 512,
  width: 576,
  svgPath: "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z",
  yOffset: 0,
  xOffset: 0,
  svgClassName: undefined,
};

export const CreditCardIcon = createIcon(CreditCardIconConfig);

export default CreditCardIcon;